import { AccountOpenedComponent } from '@shared/errors/modal/containers/account-opened/account-opened.component';
import { AnswersVerifiedComponent } from '@shared/errors/modal/containers/answers-verified/answers-verified.component';
import { AttemptsComponent } from '@shared/errors/modal/containers/attempts/attempts.component';
import { BridgerInsightComponent } from '@shared/errors/modal/containers/bridger-insight/bridger-insight.component';
import { EquifaxQuestionsComponent } from '@shared/errors/modal/containers/equifax-questions/equifax-questions.component';
import { FatcaNotAllowedComponent } from '@shared/errors/modal/containers/fatca-not-allowed/fatca-not-allowed.component';
import { IdleTimeoutComponent } from '@shared/errors/modal/containers/idle-timeout/idle-timeout.component';
import { InfoNotLoadedComponent } from '@shared/errors/modal/containers/info-not-loaded/info-not-loaded.component';
import { PageNotFoundComponent } from '@shared/errors/modal/containers/page-not-found/page-not-found.component';
import { RecaptchaComponent } from '@shared/errors/modal/containers/recaptcha/recaptcha.component';
import { ShowAppsComponent } from '@shared/errors/modal/containers/show-apps/show-apps.component';
import { TimeOutComponent } from '@shared/errors/modal/containers/time-out/time-out.component';
import { ValidateDocumentComponent } from '@shared/errors/modal/containers/validate-document/validate-document.component';
import { ValidateIdentityComponent } from '@shared/errors/modal/containers/validate-identity/validate-identity.component';
import { WithdrawalAgencyComponent } from '@shared/errors/modal/containers/withdrawal-agency/withdrawal-agency.component';
import { WithoutDpfComponent } from '@shared/errors/modal/containers/without-dpf/without-dpf.component';
import { WithoutLoanComponent } from '@shared/errors/modal/containers/without-loan/without-loan.component';

const Errors = new Map();
Errors.set('ACCOUNT_OPENED', AccountOpenedComponent);
Errors.set('ANSWERS_VERIFIED', AnswersVerifiedComponent);
Errors.set('ATTEMPTS', AttemptsComponent);
Errors.set('IDLE_TIMEOUT', IdleTimeoutComponent);
Errors.set('INFO_NOT_LOADED', InfoNotLoadedComponent);
Errors.set('PAGE_NOT_FOUND', PageNotFoundComponent);
Errors.set('BRIDGER_INSIGHT', BridgerInsightComponent);
Errors.set('TIME_OUT', TimeOutComponent);
Errors.set('RECAPTCHA', RecaptchaComponent);
Errors.set('WITHOUT_LOAN', WithoutLoanComponent);
Errors.set('WITHOUT_DPF', WithoutDpfComponent);
Errors.set('VALIDATE_IDENTITY', ValidateIdentityComponent);
Errors.set('VALIDATE_DOCUMENT', ValidateDocumentComponent);
Errors.set('EQUIFAX_QUESTION', EquifaxQuestionsComponent);
Errors.set('WITHDRAWAL_AGENCY', WithdrawalAgencyComponent);
Errors.set('SHOW_APPS', ShowAppsComponent);
Errors.set('FATCA_NOT_ALLOWED', FatcaNotAllowedComponent);
export { Errors };
